<template lang="pug">
.header
    h3.title {{ $t('settings_tab.admin_tab.feedback_interval.title') }}
    aiq-tooltip(:content="$t('settings_tab.admin_tab.feedback_interval.tooltip')"
      placement="top")
      fa-icon.question-mark(:icon="['fas', 'circle-question']")

.form-container
  .form-field-container
   .form-field-label {{ $t('settings_tab.admin_tab.feedback_interval.enabled') }}
        aiq-switch.margin-left-10(:model-value="config.enable" @change="onEnabled"
            style="--aiq-switch-on-color: #30C28B; --aiq-switch-off-color: #C0CCDA")
   .form-field-container(v-if="config.enable")
    .form-field-label {{ $t('settings_tab.admin_tab.feedback_interval.interval') }}
        aiq-input.intrval-input(v-model="config.feedback_interval"
            :placeholder="$t('settings_tab.admin_tab.feedback_interval.interval_placeholder')"
            size="small"
            type="number"
            min="1"
            @keydown.enter="saveInterval()")
</template>

<script>
export default {
  name: 'feedback-interval',
  data() {
    return {
      config: {
        enable: false,
        feedback_interval: 0,
      },
    };
  },
  async mounted() {
    this.config = await this.$store.dispatch('settings/getSetting', {
      name: 'feedback_interval',
    });
  },
  methods: {
    onEnabled(value) {
      this.config.enable = value;
      this.saveInterval();
    },
    async saveInterval() {
      try {
        this.config.feedback_interval = parseInt(this.config.feedback_interval);
        if (this.config.feedback_interval < 1) {
          this.$aiq.notify.info(this.$t('settings_tab.admin_tab.feedback_interval.invalid_days'));
          return;
        }
        await this.$store.dispatch('settings/updateSetting', {
          name: 'feedback_interval',
          payload: this.config,
        });
        this.$aiq.notify.success(this.$t('settings_tab.admin_tab.feedback_interval.success'));
      } catch (error) {
        this.$aiq.notify.error(this.$t('settings_tab.admin_tab.feedback_interval.error'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  width: 200px;
  justify-content: space-between;
}
.form-container {
  margin-top: 20px;
}
.form-field-container {
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
}
.form-field-label {
  font-weight: bold;
}

.intrval-input {
  width: 250px;
  margin-left: 10px;
}
</style>